// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3d6496a7","455":"426ad7c4","977":"f9bee917"}[chunkId] + ".chunk.js";
};